import { render, staticRenderFns } from "./IconMessages.vue?vue&type=template&id=3bf30ddc&functional=true"
import script from "./IconMessages.vue?vue&type=script&lang=js"
export * from "./IconMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports